import { createFileRoute } from "@tanstack/react-router";
import { metadataHead } from "src/lib/Metadata";
import { InlineRouteErrorPage } from "src/routes/-components/RouteBoundaries";
import { getBlogIndex } from "src/server/functions/Blog";

const DESCRIPTION =
  "Product updates from the CalmLens team: how each feature works, how to integrate it and where its limits are.";

// The post list is a server component (src/server/functions/Blog.tsx); it changes only with a deploy.
export const Route = createFileRoute("/blog/")({
  loader: () => getBlogIndex(),
  staleTime: Number.POSITIVE_INFINITY,
  head: () =>
    metadataHead({
      title: "Blog",
      description: DESCRIPTION,
      alternates: { canonical: "/blog" },
      openGraph: {
        type: "website",
        url: "/blog",
        title: "CalmLens blog",
        description: DESCRIPTION,
      },
    }),
  component: () => <>{Route.useLoaderData()}</>,
  // Inside the blog layout's header and footer (the router's default error page has its own).
  errorComponent: InlineRouteErrorPage,
});
